import React from 'react';
import { whyUsData } from '../data/mock';
import { CheckCircle } from 'lucide-react';

const WhyUs = () => {
  return (
    <section className="py-24 lg:py-32 bg-gradient-to-b from-black via-gray-900/50 to-black relative overflow-hidden">
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        
        {/* Section Title */}
        <div className="text-center mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            {whyUsData.sectionTitle}
          </h2>
          <div className="w-20 h-1 bg-accent-red mx-auto"></div>
        </div>

        {/* Differentiators Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {whyUsData.differentiators.map((item) => (
            <div 
              key={item.id}
              className="bg-gradient-to-br from-black/60 to-gray-900/60 backdrop-blur-sm border border-gold/10 rounded-2xl p-8 hover:border-gold/30 transition-all group"
            >
              {/* Icon */}
              <div className="w-12 h-12 bg-gold/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-gold/20 transition-colors">
                <CheckCircle className="text-gold" size={24} />
              </div>

              {/* Title */}
              <h3 className="text-xl lg:text-2xl font-bold text-white mb-4 group-hover:text-gold transition-colors">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-white/70 leading-relaxed text-base">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
